/* eslint-disable camelcase */
import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import _get from "lodash/get"
import { scroller } from "react-scroll"
import useWindowResize from "@/hooks/useWindowResize"
import { createContextLogger } from "@/utils/logger/client"
import { cloneDeep } from "lodash"

import style from "@/components/ProductDetail/v3/ProductDetailView/productDetailsView.module.scss"

import {
  closeModalAnalytics,
  getCartItemType,
  getCurrentSkuCouponDiscounts,
  getUserAnalyticsObject,
  isShowAnalyticsEventLoaded,
  pdpTypeFormat,
  preventBodyScroll,
  sanitizeTextForAnalytics,
  getShortenedUrlwithGeneral,
} from "@/utils/helper"

import { isANYPersona } from "@/constants/"
import { getRequireItems } from "@/components/ProductDetail/v3/productDetailsHelper"

import PdpProgressiveLoader from "@/components/ProductDetail/v2/ProgressiveLoader/PdpProgressiveLoader"
import ImageGallery from "@/components/ImageGallery/v2/ImageGallery"
import ProductDescription from "@/components/ProductDetail/v3/ProductDetailView/ProductDescription"
import ProductBreadcrumb from "@/components/ProductDetail/v3/ProductDetailView/ProductBreadcrumb"
import StickyHead from "@/components/ProductDetail/v3/ProductDetailView/StickyHead"
import AlbyQA from "@/components/AlbyQA"

import {
  setPageObject,
  selectGenericState,
} from "@/store/features/genericSlice"

import {
  getDiscontinuedProductValue,
  getReqItemLwData,
  fetchPdpRequiredItems,
  selectPdpState,
} from "@/store/features/pdpSlice"

import toolTipIcon from "@/public/icons/tooltip.svg"
import { getBundleIncludedItems } from "@/components/ProductDetail/v3/ProductDetailView/ProductDescription/utils"
import { addPageLoadAnalytics } from "@/components/ProductDetail/v3/ProductDetailView/analytics/analytics"

const ProductDetailView = props => {
  const {
    viewLoader = true,
    config = {},
    colorsData = [],
    staticTexts = {},
    badgesProps = {},
    presetConfigObject = {},
    discountedPrice = "",
    price = "",
    productOnStock = "",
    sku = "",
    customerFacingSKU = "",
    isComboSku = false,
    customerBrandName = "",
    disableRatings = false,
    replaceAddToCartCtaLink = "",
    replaceAddToCartCtaLabel = "",
    linkNewTab = false,
    currencySign = "",
    imagesData = [],
    onAddToCart = () => {},
    stickyHeaderProps = {},
    addToCartProps = {},
    onAvailableColor = () => {},
    isRegionSoldOnline = true,
    replaceAddToCart = "",
    productCategory = "",
    productLCategory = "",
    name = "",
    desc = "",
    discountPercent = 0,
    superSku = "",
    selectedColor = "",
    businessUnitName = "",
    productSaleable = "",
    productPartnerBuyNow = "",
    globalDiscount = 0,
    cart = {},
    ProductPriceSpiderIncluded_s: ProductIsRetail = "",
    discontinuedProductb = "",
    ProductRequiredAccessoriesGroupsList = [],
    loadShowEvent = "",
    setProductInfo = () => {},
    clickedProductVariant = "",
    removeVariantSelection = () => {},
    requiredItems = [],
    addItemsToCart = () => {},
    discontinuedProduct = false,
    imageClickCounter = 0,
    updateImageClickCounter = () => {},
    productData = {},
    initialImgAlt = "",
    initialImgUrl = "",
    pdpJson = {},
    waterSenseProduct = [],
    setIsLoadTargetRequired,
    isLoadTargetRequired,
    isPriceChecked = false,
    ctData = {},
    persona = "",
    productDetailData = {},
    threeSixtyResourceData = {},
    savedListLineItems = {},
    regionBrandNames = {},
    productCollectionsName = "",
    isIscUser = false,
    selectedSku = "",
  } = props || {}

  const logger = createContextLogger("pdp:view")

  const { featureFlags = {} } = useSelector(selectGenericState)
  const { ENABLE_ALBY_FOR_PERSONAS: ENABLE_ALBY_FOR_PERSONAS = "" } =
    featureFlags
  const albyPersonaList = ENABLE_ALBY_FOR_PERSONAS
    ? ENABLE_ALBY_FOR_PERSONAS.split(",")
    : []

  const dispatch = useDispatch()
  const [priceTooltip, setPriceTooltip] = useState(false)
  const [showPDPInstallModal, setShowPDPInstallModal] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)
  const [installReq, setInstallReq] = useState([])
  const [installReqData, setInstallReqData] = useState([])
  const [reqItemLwData, setReqItemLwData] = useState([])
  const [currentQuantity, setCurrentQuantity] = useState(1)
  const [priceList, setPriceList] = useState()
  const [subTotal, setSubTotal] = useState()
  const [showStickyHeader, setShowStickyHeader] = useState(false)
  const [isMobileOnly, setIsMobileOnly] = useState(false)
  const [albyThreadId, setAlbyThreadId] = useState("")
  const [showAlby, setShowAlby] = useState(false)

  const addCartContainer = useRef(null)
  const [sourceData, setSourceData] = useState(null)
  const { productNo = "" } = sourceData || {}

  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage("request-pdp-data", window.location.origin)
    }

    const handleMessage = event => {
      if (
        event.origin === window.location.origin &&
        event.data?.from === "result"
      ) {
        setSourceData(event.data.payload)
        sessionStorage.setItem("GVS", JSON.stringify(event.data.payload))
      }
    }

    window.addEventListener("message", handleMessage)
    return () => window.removeEventListener("message", handleMessage)
  }, [])

  const rightSectionRef = useRef(null)
  const {
    pdp: { data: { primaryBundleSKU_s: primaryBundleSKUs = "" } = {} } = {},
  } = useSelector(selectPdpState)

  const isBundleProduct = Boolean(primaryBundleSKUs)

  const {
    general = {},
    general: { swatchUrl = "", scene7AccountName = "" } = {},
    plpServletPath,
    internationalization: { currencyCode = "" } = {},
  } = config || {}

  const {
    disableCommerce = false,
    siteName: brandName = "",
    homepageUrl = "",
    scene7AccountName: assetAccountName = "PAWEB",
    lwAppName = "",
  } = general

  const {
    ProductLocalCategory_s: productLocalCategory = "",
    isCollapsedPDP_b: isCollapsedPDP = false,
  } = productData

  const homePagePath = getShortenedUrlwithGeneral(homepageUrl, general)

  const disableEcommerce = Boolean(disableCommerce)
  const isPersonaANY = isANYPersona

  const { availableStock = 0, backOrder = "" } = addToCartProps

  const masterVariantProductNo =
    ctData?.masterVariant?.attributes?.find(
      attr => attr.name === "ProductProductNo"
    )?.value || ""

  const badgeTxt = badgesProps.isNewProduct
    ? badgesProps.exclusiveBadge
      ? staticTexts.newExclusive
      : staticTexts.new
    : badgesProps.exclusiveBadge
    ? staticTexts.exclusive
    : badgesProps.badgeVal
    ? staticTexts.sale
    : ""

  const [width] = useWindowResize()

  useEffect(() => {
    if (width > 0) {
      setIsMobileOnly(width <= 480)
    }
  }, [width])

  // To get the bundle's items
  const {
    pdp: { bundleIncludedItems = [] } = {},
    productServices: currentProductServices = [],
  } = useSelector(selectPdpState)
  const includedItems = getBundleIncludedItems({
    items: bundleIncludedItems,
    ctData,
    projectionData: currentProductServices,
    currencyCode,
    persona,
  })

  const getProductAnalyticsData = () => {
    return {
      desc: sanitizeTextForAnalytics(desc),
      discountPrice: discountedPrice,
      discountPriceState:
        discountPercent > 0 ? "percentOff|" + discountPercent : "regular price",
      unitPrice: price,
      category: sanitizeTextForAnalytics(productCategory),
      lcategory: sanitizeTextForAnalytics(productLCategory),
      color: sanitizeTextForAnalytics(
        _get(
          colorsData.find(item => item.id === sku),
          "label",
          ""
        )
      ),
      sku,
      visualSearch: productNo !== "" && sku?.includes(productNo),
      name: sanitizeTextForAnalytics(name),
      quantity: currentQuantity,
      image: imagesData[0]?.url,
      stock: productOnStock,
      availability:
        discontinuedProduct || discontinuedColor
          ? "discontinued"
          : backOrder === "Yes" && availableStock <= 0
          ? "back order"
          : availableStock > 0
          ? "in stock"
          : "out of stock",
      customerFacingSKU:
        customerFacingSKU || (brandName ? brandName[0] + "-" + sku : ""),
      skuInitials: customerFacingSKU
        ? customerFacingSKU.split("-")[0] + "-"
        : brandName
        ? brandName[0] + "-"
        : "",
      discountName: badgesProps?.badgeVal,
      superSku,
      selectedColor: sanitizeTextForAnalytics(selectedColor),
      businessUnitName: sanitizeTextForAnalytics(businessUnitName),
      productSaleable,
      brandName: brandName?.toLowerCase(),
      productPartnerBuyNow,
      productCollectionsName: sanitizeTextForAnalytics(productCollectionsName),
      globalDiscount,
      pdpType: isBundleProduct ? "bundle" : "",
      bundleIds: isBundleProduct
        ? includedItems?.map(item => "K-" + item.sku).toString()
        : "",
      bundleItemsCategories: isBundleProduct
        ? includedItems
            ?.map(item => sanitizeTextForAnalytics(item.category))
            .toString()
        : "",
      bundleItemsCollections: isBundleProduct
        ? includedItems
            ?.map(item => sanitizeTextForAnalytics(item.collection))
            .toString()
        : "",
      bundleProductRoom: isBundleProduct
        ? sanitizeTextForAnalytics(
            includedItems.filter(item => item.sku === primaryBundleSKUs)?.[0]
              ?.productRoom ?? ""
          )
        : "",
      bundleProductColors: isBundleProduct
        ? includedItems
            ?.map(item => sanitizeTextForAnalytics(item.color))
            .toString()
        : "",
    }
  }

  const { productCouponCode, productCoupondiscount } =
    getCurrentSkuCouponDiscounts({
      cart,
      sku,
    })
  const { pdpDesktopImage, enableAlby = false, widgetId = "" } = pdpJson
  let waterSenseProductVal = false
  if (waterSenseProduct && waterSenseProduct.length) {
    waterSenseProductVal = waterSenseProduct[0] === "Yes" ? true : false
  }

  const getProcessedProductInfo = (updatedPageInfo = false) => {
    const productAnalyticsData = getProductAnalyticsData()
    const productInfo = {
      description: productAnalyticsData.desc || "n/a",
      frequency: "n/a",
      globalPromotionPrice: Number(
        productAnalyticsData?.discountPrice || productAnalyticsData?.unitPrice
      ),
      isRecommended: "n/a",
      isSendNow: "n/a",
      isSubscription: "n/a",
      priceState: productAnalyticsData.discountPriceState,
      productBasePrice: productAnalyticsData.unitPrice || "n/a",
      productCategory:
        productAnalyticsData.category ||
        productAnalyticsData.businessUnitName ||
        "n/a",
      productColor: productAnalyticsData.color || "n/a",
      productCoupondiscount: productCoupondiscount,
      productCouponCode: productCouponCode.join("|") || "n/a",
      productID: productAnalyticsData.customerFacingSKU || "n/a",
      productName: productAnalyticsData.name || "n/a",
      productPartnerBuyNow: productAnalyticsData.productPartnerBuyNow,
      productRoom: isBundleProduct
        ? productAnalyticsData.bundleProductRoom
        : productAnalyticsData.businessUnitName ||
          productAnalyticsData.category,
      productSalePrice: productAnalyticsData?.discountPrice
        ? productAnalyticsData?.discountPrice
        : productAnalyticsData?.unitPrice,
      productSaleable: productAnalyticsData.productSaleable,
      productStatus: ProductIsRetail
        ? "retail exclusive"
        : productAnalyticsData.availability,
      productSuperSku: productAnalyticsData.superSku ? true : false,
      productSkuOption: isCollapsedPDP,
      productTileName: productAnalyticsData.name || "n/a",
      quantity: productAnalyticsData.quantity || "n/a",
      defaultImageName: productAnalyticsData.image || "n/a",
      ratings: "n/a",
      numberOfReviews: "n/a",
      pdpType: isBundleProduct
        ? "bundle"
        : pdpTypeFormat({
            businessUnitName,
            ProductIsRetail,
            discontinuedProductb,
            ProductRequiredAccessoriesGroupsList,
            superSku,
          }),
      productFindingMethod: "n/a",
      productCollectionsName: isBundleProduct
        ? productAnalyticsData.bundleItemsCollections
        : sanitizeTextForAnalytics(regionBrandNames) ||
          productAnalyticsData.productCollectionsName ||
          productAnalyticsData.category ||
          "n/a",
      productBrand: productAnalyticsData.brandName,
      globalOffer: productAnalyticsData.discountName || "n/a",
      globalDiscount: productAnalyticsData?.globalDiscount
        ? Number(
            (
              productAnalyticsData.unitPrice -
              (productAnalyticsData?.discountPrice ||
                productAnalyticsData?.unitPrice)
            ).toFixed(2)
          )
        : 0,
      itemType: getCartItemType(
        productAnalyticsData.category,
        productAnalyticsData.businessUnitName
      ),
      category: isBundleProduct
        ? productAnalyticsData.bundleItemsCategories
        : productAnalyticsData.lcategory ||
          productAnalyticsData.businessUnitName ||
          "n/a",
      waterSenseProduct: waterSenseProductVal,
      bundleIds: productAnalyticsData.bundleIds
        ? productAnalyticsData.bundleIds
        : "n/a",
      bundleProductColors: productAnalyticsData.bundleProductColors
        ? productAnalyticsData.bundleProductColors
        : "n/a",
      productImageGallery: false,
      visualSearch:
        productNo !== "" && productAnalyticsData?.sku?.includes(productNo),
    }

    if (updatedPageInfo) {
      window.productInfo = JSON.stringify(productInfo)
      window.pageObj.productInfo = { ...productInfo }
      dispatch(setPageObject(true))
    }
    if (disableEcommerce) {
      productAnalyticsData.stringProductInfo = JSON.stringify({
        productInfo,
      })
    } else {
      productAnalyticsData.stringProductInfo = JSON.stringify({
        page: { cart: { cartID: cart?.id } },
        productInfo,
      })
    }
    return {
      productAnalyticsData,
      productInfo,
    }
  }

  const addCartCallback = entries => {
    const [entry] = entries
    const currentValue =
      !entry?.isIntersecting && entry?.boundingClientRect?.y < 0
    setShowStickyHeader(currentValue)
  }

  const options = { root: null, rootMargin: "0px", threshold: 1.0 }

  useEffect(() => {
    if (installReq.length > 0) {
      getRequireItems(
        installReq,
        discountedPrice,
        price,
        () => setInstallReq(installReq),
        subtotal => setSubTotal(subtotal),
        priceList => setPriceList(priceList),
        cartItem => addItemsToCart(cartItem, false)
      )
    }
  }, [sku])

  useEffect(() => {
    const data = {
      pageLoadAnalyticsTimer: null,
      getProcessedProductInfo,
      productLocalCategory,
      imagesData,
      isShowAnalyticsEventLoaded,
      getUserAnalyticsObject,
      setProductInfo,
      productImagesWithUrls:
        productDetailData?.[`productImages.labelWithUrl_ss`] || "",
    }

    if (
      window.pageObj &&
      loadShowEvent &&
      window.datalayerTopLoaded &&
      window.adobeDataLayer.length > 0
    ) {
      addPageLoadAnalytics(data)
    } else {
      data.pageLoadAnalyticsTimer = setInterval(() => {
        addPageLoadAnalytics(data)
      }, 500)
    }

    return () => {
      setProductInfo(null)
      delete window.productInfo
      clearInterval(data.pageLoadAnalyticsTimer)
    }
  }, [loadShowEvent, isPriceChecked])

  useEffect(() => {
    if (clickedProductVariant) {
      // add a click event as use has selected differenct product color/variant
      removeVariantSelection()
      if (!isLoadTargetRequired) {
        const page = cloneDeep(window.pageObj || {})
        const userObj = getUserAnalyticsObject()
        page.user = { ...page.user, ...userObj }
        const kohlerDatalayer = window.kohler.datalayer
        kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
          page: page,
          eventMetaData: {
            experience: "pdp",
            eventType: "genericEvent",
            params: {
              type: "color selection",
              needsJSON: true,
              selectedColor,
              selectedSku,
            },
          },
        })
      } else {
        window.initDataLayerTop()
        setIsLoadTargetRequired(false)
      }
      setProductInfo(productAnalyticsData.stringProductInfo)
    }
  }, [clickedProductVariant])

  useEffect(() => {
    const fetchRequiredItems = async () => {
      let query = ""
      let lwQuery = ""
      requiredItems.forEach((item, i) => {
        query = query + `"${item}"${i !== requiredItems.length - 1 ? "," : ""}`
        lwQuery += `"${item}" `
      })
      const lwPayload = { lwQuery, brandName, lwAppName }
      dispatch(fetchPdpRequiredItems(query))
        .unwrap()
        .then(response => {
          setInstallReqData(response)
          dispatch(getReqItemLwData(lwPayload))
            .unwrap()
            .then(lwData => setReqItemLwData(lwData ?? []))
            .catch(error => {
              logger.error("Failed to fetch required items data from LW", {
                error,
                lwPayload,
              })
            })
        })
        .catch(error => {
          logger.error("Failed to fetch required PDP items data", {
            error,
            query,
          })
        })
    }
    if (
      requiredItems?.length > 0 &&
      showPDPInstallModal &&
      installReqData.length === 0
    ) {
      fetchRequiredItems()
    }
  }, [requiredItems, showPDPInstallModal, installReqData])

  useEffect(() => {
    if (width > 1023) {
      const observer = new IntersectionObserver(addCartCallback, options)
      if (addCartContainer?.current) observer.observe(addCartContainer.current)

      return () => {
        if (addCartContainer?.current)
          observer.observe(addCartContainer.current)
      }
    }
  }, [addCartContainer, options])

  const onModalClose = () => {
    setShowPDPInstallModal(false)
    preventBodyScroll(false)
  }

  const onInstallCTA = () => {
    setShowPDPInstallModal(true)
    preventBodyScroll(true)
  }

  const handleInfoToolTipHover = e => {
    e.stopPropagation()
    setShowTooltip(true)

    const kohlerDatalayer = window.kohler.datalayer
    kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
      eventMetaData: {
        experience: "pdp",
        eventType: "genericEvent",
        params: {
          type: staticTexts.toolTip.toLowerCase(),
          needsJSON: true,
        },
      },
    })
  }

  const handleRemove = i => {
    const priceListItems = []
    let requiredItemsPrice = 0
    let priceLists = 0
    let baseTotal = 0
    let subTotalItem = 0
    let curValue = installReq
    curValue = installReq.filter(f => f.skuid !== i.skuid)
    setInstallReq(curValue)
    const cartItemProduct = []
    if (curValue.length > 0) {
      curValue &&
        curValue.forEach(currentItem => {
          const product = {
            sku: currentItem.skuid,
            quantity: !checkQuantity ? 1 : 0,
          }
          product.sku = currentItem.skuid
          const checkQuantity = _get(
            currentItem.colorsData.find(
              requiredItem => requiredItem.id === currentItem.skuid
            ),
            "isOutOfStock",
            false
          )
          product.quantity = !checkQuantity ? 1 : 0
          if (!checkQuantity) {
            cartItemProduct.push(product)
          }
          if (currentItem?.priceData) {
            priceLists =
              _get(
                currentItem.priceData.find(
                  requiredList => requiredList.id === currentItem.skuid
                ),
                "discountedPrice",
                0
              ) > 0
                ? _get(
                    currentItem.priceData.find(
                      requiredList => requiredList.id === currentItem.skuid
                    ),
                    "discountedPrice",
                    0
                  )
                : _get(
                    currentItem.priceData.find(
                      requiredList => requiredList.id === currentItem.skuid
                    ),
                    "price",
                    0
                  )

            priceListItems.push(priceLists)
            if (priceListItems.length >= 0) {
              requiredItemsPrice = priceListItems.reduce((acc, currentItem) => {
                return parseFloat(acc) + parseFloat(currentItem)
              }, 0)
            } else {
              requiredItemsPrice = priceListItems[0]
            }
            baseTotal = discountedPrice > 0 ? discountedPrice : price
            subTotalItem = baseTotal + requiredItemsPrice
            setSubTotal(subTotalItem)
            setPriceList(requiredItemsPrice)
          }
        })
      addItemsToCart(cartItemProduct, false)
    } else {
      addItemsToCart([], false)
    }
  }

  const comparedProductsCount = Number(_get(props, "comparedProductsCount", 0))

  const discontinuedColor = _get(
    colorsData.find(item => item.id === sku),
    "discontinuedColor",
    ""
  )
  let isDiscontinued = false
  let isColorDiscontinued = false

  if (discontinuedProduct) {
    isDiscontinued = true
    getDiscontinuedProductValue(isDiscontinued)
  } else if (discontinuedColor) {
    isDiscontinued = true
    isColorDiscontinued = true
    getDiscontinuedProductValue(isDiscontinued)
  }

  const handleNavChange = (navActive, addToDatalayer = false) => {
    if ((navActive === 4 || addToDatalayer) && window.adobeDataLayer) {
      // adding a click even on Write a review button Requirement#47
      const { productAnalyticsData = {} } = getProcessedProductInfo()

      const kohlerDatalayer = window.kohler.datalayer
      kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
        eventMetaData: {
          experience: "pdp",
          eventType: "genericEvent",
          params: {
            type: "write a review",
            needsJSON: true,
          },
        },
      })
      closeModalAnalytics(productAnalyticsData.stringProductInfo)
    }
  }

  const handleQtyChange = qty => {
    if (qty) {
      setCurrentQuantity(qty)
    }
  }

  const handleScroll = () => {
    scroller.scrollTo("buy-area", {
      duration: 1500,
      delay: 0,
      smooth: "easeInOutQuart",
    })
  }

  const handleSetPriceTooltip = (type, needsToSetState, tooltipContent) => {
    if (needsToSetState) setPriceTooltip(true)
    if (!window.isHoverLoaded) {
      window.isHoverLoaded = true

      setTimeout(() => {
        const kohlerDatalayer = window.kohler.datalayer
        kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
          eventMetaData: {
            experience: "pdp",
            eventType: "genericEvent",
            params: {
              type: type,
              needsJSON: true,
              toolTipText: tooltipContent,
            },
          },
        })
        delete window.isHoverLoaded
      }, 1400)
    }
  }

  const { productAnalyticsData = {}, productInfo = {} } =
    getProcessedProductInfo()

  useEffect(() => {
    const handleThreadCreated = e => {
      const { threadId } = e.detail
      if (threadId) {
        setAlbyThreadId(threadId)
      }
    }
    document.addEventListener(
      "alby:GenerativeQA::ThreadCreated",
      handleThreadCreated
    )
    return () => {
      document.removeEventListener(
        "alby:GenerativeQA::ThreadCreated",
        handleThreadCreated
      )
    }
  }, [])

  useEffect(() => {
    setShowAlby(
      enableAlby &&
        widgetId &&
        masterVariantProductNo &&
        (albyPersonaList?.includes(persona) ||
          (isIscUser && albyPersonaList?.includes("ISC")))
    )
  }, [
    enableAlby,
    widgetId,
    masterVariantProductNo,
    persona,
    isIscUser,
    albyPersonaList,
  ])

  return (
    <>
      <StickyHead
        isDiscontinued={isDiscontinued}
        showStickyHeader={showStickyHeader}
        stickyHeaderProps={stickyHeaderProps}
        discountedPrice={discountedPrice}
        price={price}
        staticTexts={staticTexts}
        onAddToCart={onAddToCart}
        isColorDiscontinued={isColorDiscontinued}
        addToCartProps={addToCartProps}
        productOnStock={productOnStock}
        sku={sku}
        customerFacingSKU={customerFacingSKU}
        isComboSku={isComboSku}
        handleScroll={handleScroll}
        onAvailableColor={onAvailableColor}
        isRegionSoldOnline={isRegionSoldOnline}
        productAnalyticsData={productAnalyticsData}
        customerBrandName={customerBrandName}
        replaceAddToCart={replaceAddToCart}
        disableRatings={disableRatings}
        replaceAddToCartCtaLink={replaceAddToCartCtaLink}
        replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
        linkNewTab={linkNewTab}
        disableEcommerce={disableEcommerce}
        currencySign={currencySign}
        swatchUrl={swatchUrl}
        imagesData={imagesData}
        presetConfigObject={presetConfigObject}
        assetAccountName={assetAccountName}
        productPriceSpiderIncluded={ProductIsRetail}
      />
      {viewLoader ? (
        <PdpProgressiveLoader />
      ) : (
        <div className={style.productDetailsV3Wrapper}>
          <div className="product-detail-page" role="main">
            <div className="container">
              <ProductBreadcrumb
                staticTexts={staticTexts}
                productCategory={productCategory}
                name={name}
                homePagePath={homePagePath}
                plpServletPath={plpServletPath}
                config={config}
                productAnalyticsData={productAnalyticsData}
                productData={productData}
                swatchUrl={swatchUrl}
                imagesData={imagesData}
                width={width}
                presetConfigObject={presetConfigObject}
                isBundleProduct={isBundleProduct}
              />
              <div className="product-overview print-overview">
                <div className="product-detail-page__image-gallery print-overview-left">
                  <div className="product-detail-page__left-sticky">
                    <ImageGallery
                      data={imagesData}
                      imageClickCounter={imageClickCounter}
                      updateImageClickCounter={updateImageClickCounter}
                      productInfo={productAnalyticsData.stringProductInfo}
                      page="pdp"
                      staticTexts={staticTexts}
                      presetConfigObject={presetConfigObject}
                      swatchUrl={swatchUrl}
                      assetAccountName={scene7AccountName ?? "PAWEB"}
                      initialImgAlt={initialImgAlt}
                      initialImgUrl={initialImgUrl}
                      pdpDesktopImage={pdpDesktopImage}
                      productImagesWithResourceTypes={
                        productDetailData?.[`productImages.labelWithUrl_ss`]
                      }
                      threeSixtyResourceData={threeSixtyResourceData}
                      clickedProductVariant={clickedProductVariant}
                      pdpJson={pdpJson}
                      sku={sku}
                      productData={productData}
                    />
                    {showAlby && width >= 1024 ? (
                      <AlbyQA
                        widgetId={widgetId}
                        skuId={masterVariantProductNo}
                        threadId={albyThreadId}
                      />
                    ) : null}
                  </div>
                </div>
                <div className="product-detail-page__content-section print-overview-right">
                  <ProductDescription
                    ref={{ rightSectionRef, addCartContainer }}
                    badgeTxt={badgeTxt}
                    isDiscontinued={isDiscontinued}
                    isPersonaANY={isPersonaANY}
                    productInfo={productInfo}
                    priceTooltip={priceTooltip}
                    handleSetPriceTooltip={handleSetPriceTooltip}
                    setPriceTooltip={setPriceTooltip}
                    installReq={installReq}
                    productAnalyticsData={productAnalyticsData}
                    onInstallCTA={onInstallCTA}
                    toolTipIcon={toolTipIcon}
                    handleInfoToolTipHover={handleInfoToolTipHover}
                    setShowTooltip={setShowTooltip}
                    showTooltip={showTooltip}
                    isMobileOnly={isMobileOnly}
                    handleRemove={handleRemove}
                    priceList={priceList}
                    subTotal={subTotal}
                    getRequireItems={items =>
                      getRequireItems(
                        items,
                        discountedPrice,
                        price,
                        () => setInstallReq(items),
                        subtotal => setSubTotal(subtotal),
                        priceList => setPriceList(priceList),
                        cartItem => addItemsToCart(cartItem, false)
                      )
                    }
                    installReqData={installReqData}
                    reqItemLwData={reqItemLwData}
                    onModalClose={onModalClose}
                    showPDPInstallModal={showPDPInstallModal}
                    onQtyChange={handleQtyChange}
                    comparedProductsCount={comparedProductsCount}
                    isColorDiscontinued={isColorDiscontinued}
                    handleNavChange={handleNavChange}
                    disableEcommerce={disableEcommerce}
                    savedListLineItems={savedListLineItems}
                    enableAlby={enableAlby}
                    widgetId={widgetId}
                    masterVariantProductNo={masterVariantProductNo}
                    albyThreadId={albyThreadId}
                    showAlby={showAlby}
                    {...props}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ProductDetailView
